import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import { Button } from './Button';
import { Heading, Text } from './Typography';

export const ErrorState = ({
                               title = 'Something went wrong',
                               description = 'An unexpected error occurred. Please try again.',
                               onRetry,
                               onHome,
                               fullPage = false,
                               className = '',
                               componentName,
                           }) => {
    const content = (
        <div
            role="alert"
            className={`flex flex-col items-center justify-center text-center ${fullPage ? 'min-h-screen px-4' : 'py-16 px-4'} ${className}`}>
            <div className="flex h-16 w-16 items-center justify-center rounded-[20px] bg-red-50 text-red-500">
                <AlertTriangle size={32} />
            </div>
            <Heading level={3} className="mt-6 text-gray-900">{title}</Heading>
            <Text variant="body" color="muted" className="mt-3 max-w-md">{description}</Text>
            <div className="flex gap-3 mt-6">
                {onRetry && (
                    <Button
                        variant="primary"
                        size="md"
                        onClick={onRetry}
                        icon={<RefreshCw size={16} />}
                    >
                        Try Again
                    </Button>
                )}
                {onHome && (
                    <Button
                        variant="secondary"
                        size="md"
                        onClick={onHome}
                        icon={<Home size={16} />}
                    >
                        Go to Home
                    </Button>
                )}
            </div>
        </div>
    );

    if (fullPage) return content;
    return <div className="rounded-[20px] border border-red-100 bg-red-50">{content}</div>;
};
